import moment from "moment";
import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import CopyString from "../utils/CopyString";

import { MODIFIED_AT_TIME_FORMAT } from "../config";

import { selectCopy } from "/state/reducers/locale/copySelector.js";

class UserDetailsPanel extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_user.details_panel"
  };

  // -- RENDER -- //

  render() {
    const { data, disabled, copyKey, copy } = this.props;

    if (!data) return null;

    return (
      <Segment className="clear-both" disabled={disabled}>
        <Header as="h3" floated="left">
          {copy(`${copyKey}.title`)}
        </Header>
        <p className="clear-both">
          <strong>{copy(`${copyKey}.id`)}: </strong>
          {data.id && <CopyString copyText={data.id} displayText={data.id} />}
          <br />
          {data.firstName && (
            <Fragment>
              <strong>{copy(`${copyKey}.first_name`)}: </strong>
              {data.firstName}
              <br />
            </Fragment>
          )}
          {data.lastName && (
            <Fragment>
              <strong>{copy(`${copyKey}.last_name`)}: </strong>
              {data.lastName}
              <br />
            </Fragment>
          )}
          {data.username && (
            <Fragment>
              <strong>{copy(`${copyKey}.username`)}: </strong>
              {data.username}
              <br />
            </Fragment>
          )}
          {data.email && (
            <Fragment>
              <strong>{copy(`${copyKey}.email`)}: </strong>
              {data.email}
              <br />
            </Fragment>
          )}
          {data.createdAt && (
            <Fragment>
              <strong>{copy(`${copyKey}.created_at`)}: </strong>
              {moment(data.createdAt).format(MODIFIED_AT_TIME_FORMAT)}
              <br />
            </Fragment>
          )}
          {data.updatedAt && (
            <Fragment>
              <strong>{copy(`${copyKey}.updated_at`)}: </strong>
              {moment(data.updatedAt).format(MODIFIED_AT_TIME_FORMAT)}
              <br />
            </Fragment>
          )}
        </p>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(UserDetailsPanel);
